
import Vue from "vue";
import AppMobileFullScreenContainer from "@/components/common/MobileFullScreenContainer.vue";
import AppToolbar from "@/components/common/ToolbarBase.vue";
import AppBrowseList from "@/components/browse/BrowseListCard.vue";
import { Browse } from "@/models/browse";
import { BrowseService } from "@/services/browse-service";
import { UserInfo } from "../../../models/dossier/user-info";
import { CompanyService } from "../../../services/company-service";
import { IBreadCrumb, ISelectItem } from "winfakt-vue-components";
import { ViewService } from "../../../services/view-service";
import AppUserImportViews from "@/components/settings-default/UserViewsImport.vue";
import AppVisibleLinks from "@/components/settings-default/VisibleLinks.vue";
import {AuthService} from "@/services/auth-service";

export default Vue.extend({
	data(){
		return {
			browses: [] as Browse[],
			userId: 0,
			user: null as null | UserInfo,
			importOpen: false
		};
	},
	computed: {
		isOwner():boolean {
			return AuthService.wfUser.ID == AuthService.wfCompany.OwnerID;
		},
		title():string {
			let username = "user";
			if (this.user){
				username = this.user.getShortDisplayName();
			}
			return this.$ct("views-of-user", {username}).toString();
		},
		path():IBreadCrumb[]{

			return [
				{
					to: "/settings/",
					value: this.$ct("general").toString()
				},
				{
					to: "/settings/users",
					value: this.$ct("users").toString()
				},
				{
					value: this.title
				}
			];
		},
		actions():ISelectItem<string>[]{
			return [
				{
					text: this.$ct("restore-default"),
					value: "restore-default"
				},
				{
					text: this.$ct("import-views"),
					value: "import-views-of-other-user"
				}
			];
		}
	},
	methods: {
		onBrowseClick(browse:Browse){
			this.$router.push(`/settings/users/views/${this.userId}/${browse.ID}`);
		},
		actionClicked(action:string){
			console.log(action);
			if (action == "restore-default"){
				this.restoreDefaultViews();
			}else if (action == "import-views-of-other-user"){
				this.importOpen = true;
			}
		},
		async restoreDefaultViews(){
			let confirm = await this.$confirmBuilder(this.$ct("confirm-restore-default-views-of-user")).setWarningTitle().show();
			if (!confirm){
				return;
			}
			await ViewService.restoreUserViews(this.userId);
		}
	},
	async created(){
		this.browses = await BrowseService.getBrowses();
		this.userId = parseInt(this.$route.params.id);
		this.user = await CompanyService.getUser(this.userId);
	},
	components: {
		AppMobileFullScreenContainer,
		AppBrowseList,
		AppToolbar,
		AppUserImportViews,
		AppVisibleLinks
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
